import { dealScoreColor, dealScoreLabel } from "../lib/colors";

export default function DealScoreChip({
  score,
  threshold,
}: { score: number | null; threshold: number }) {
  return (
    <span className={`px-2 py-0.5 rounded text-xs font-mono ${dealScoreColor(score, threshold)}`}>
      {dealScoreLabel(score)}
    </span>
  );
}
